<latch-recent-logins (cancel)="onCancelClick()">
</latch-recent-logins>
